import Axios, { AxiosError, AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { Store } from 'redux';
// import { LoadingBarActions } from '../../features/loadingBar';

const defaultAxiosInstance: AxiosInstance = Axios.create();

export const configureAxios = (storeState: Store<any>) => {
	// axiosRetry(defaultAxiosInstance, {
	//     retries: 3,
	//     retryCondition: (error: AxiosError) => {
	//         return axiosRetry.isNetworkOrIdempotentRequestError(error);
	//     },
	// });
	// defaultAxiosInstance.defaults.onDownloadProgress = (progressEvent: any) => {
	// 	storeState.dispatch(LoadingBarActions.start());
	// 	const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length');
	// 	if (totalLength !== null) {
	// 		const percentCompleted = Math.round((progressEvent.loaded * 100) / totalLength);
	// 		storeState.dispatch(LoadingBarActions.set({ loaderPercent: percentCompleted, loading: true, loadingError: false }));
	// 	}
	// 	// const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
	// 	// storeState.dispatch(LoadingBarActions[LOADER_SET]({loaderPercent: percentCompleted, loading: true, loadingError: false}));
	// };
	// defaultAxiosInstance.defaults.onUploadProgress = (progressEvent: any) => {
	// 	storeState.dispatch(LoadingBarActions.start());
	// 	const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
	// 	// console.log(progressEvent);
	// 	storeState.dispatch(LoadingBarActions.set({ loaderPercent: percentCompleted, loading: true, loadingError: false }));
	// };
	// defaultAxiosInstance.interceptors.response.use(
	// 	response => {
	// 		return response;
	// 	},
	// 	error => {
	// 		storeState.dispatch(LoadingBarActions.set({ loaderPercent: 100, loading: false, loadingError: true }));
	// 		return Promise.reject(error);
	// 	}
	// );
};

const basicConfigureNewInstance = () => {
	const newInstance = Axios.create();
	// axiosRetry(newInstance, {
	//     retries: 3,
	//     retryCondition: (error: AxiosError) => {
	//         return axiosRetry.isNetworkOrIdempotentRequestError(error);
	//     },
	// });

	return newInstance;
};

const basicConfigureNewRetryInstance = () => {
	const newInstance = Axios.create();
	axiosRetry(newInstance);

	return newInstance;
};

export default defaultAxiosInstance;
export const axiosInstance = basicConfigureNewInstance();
export const retryAxiosInstance = basicConfigureNewRetryInstance();
